// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"d7b4d526","344":"acbb1692","475":"7f5f0864","605":"917acb13","806":"bdf518b9"}[chunkId] + ".chunk.js";
};